/**
 * Component for showing images of the mansion.
 *
 * @component
 * @example
 * const mansionName = "Mansion Name"
 * const isMansionImages = true
 * const images = [{image_url: "sample1.jpg"}]
 * return (
 *   <MansionImage mansionName={mansionName} isMansionImages={isMansionImages} images={images} />
 * )
 */

// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';

// Section for import custom components --------------------------------------------------------------------------------
import DefaultImage from '@components/MansionDetail/MansionImage/DefaultImage';
import SingleImage from '@components/MansionDetail/MansionImage/SingleImage';
import ImageSlider from '@components/MansionDetail/MansionImage/ImageSlider';

// Section for type definition -----------------------------------------------------------------------------------------
type MansionImageProps = {
  mansionName: string;
  images: {
    id: string;
    image_url: {
      '2xl': string;
      lg: string;
      md: string;
      original: string;
      sm: string;
      xl: string;
      xs: string;
    };
    title: string;
    sort_id: number;
    image_branch_id: number;
    is_main: number;
    is_deleted: number;
    image_table_name: string;
    created_at: string;
    updated_at: string;
  }[];
  isMansionImages: boolean;
};

// Section for render component ----------------------------------------------------------------------------------------
export default function MansionImage(props: MansionImageProps): React.JSX.Element {
  const { mansionName, images, isMansionImages } = props;
  if (isMansionImages) {
    if (images.length === 1) {
      return <SingleImage mansionName={mansionName} images={images} />;
    }
    return <ImageSlider mansionName={mansionName} images={images} />;
  }
  return <DefaultImage images={images} />;
}
